<template>
    <v-dialog v-model="visible" persistent max-width="800px">
        <v-card class="mx-auto px-2 pb-3" outlined>
            <v-card-title class="justify-center">
                <v-spacer/>
                Cadastro de Etapas
                <v-spacer/>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <div style="display: flex; justify-content: center;">
                <v-btn class="mb-2" color="success" @click="addStep">
                    <v-icon>mdi-plus</v-icon>nova etapa
                </v-btn>
            </div>
            <v-card-text :style="`height: ${$vuetify.breakpoint.height - 220}px; overflow-x: auto;`">
                <v-skeleton-loader
                    v-if="loading"
                    class="mx-auto"
                    type="card"
                    height="100"
                />
                <v-expansion-panels v-model="panel" v-else>
                    <v-expansion-panel v-for="(passo, i) in passos" :key="'ativo-' + i" ref="paineis">
                        <v-expansion-panel-header>
                            <div style="display: flex; align-items: flex-end;">
                                <div>
                                    <v-btn
                                        icon
                                        color="error"
                                        title="Excluir"
                                        @click.stop="deleteStep(passo.id, i)"
                                    >
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                                <div>
                                    <v-btn
                                        icon
                                        color="primary"
                                        @click.stop="duplicateStep(i)"
                                        title="Duplicar"
                                    >
                                        <v-icon>mdi-plus-circle-multiple-outline</v-icon>
                                    </v-btn>
                                </div>
                                <div>
                                    <v-btn
                                        icon
                                        color="success"
                                        title="Salvar"
                                        @click.stop="saveStep(i)"
                                        :loading="loadingSalvar === i"
                                    >
                                        <v-icon>mdi-content-save</v-icon>
                                    </v-btn>
                                </div>
                                <div class="ml-5 mb-2" style="font-weight: bold; text-transform: uppercase;">
                                    {{ passo.id ? `${passo.id} - ` : '' }} {{ rotulo(passo) }}
                                </div>
                                <div v-if="passo.produtos" class="ml-2 mb-2">
                                    <v-tooltip bottom max-width="320">
                                        <template #activator="{ on, attrs }">
                                            <v-chip
                                                x-small
                                                outlined
                                                :color="passo.produtos.length ? '' : 'grey'"
                                                :class="{ 'chip-sem-produto': !passo.produtos.length }"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click.stop
                                            >
                                                <v-icon x-small left>mdi-hamburger</v-icon>{{ passo.produtos.length }}
                                            </v-chip>
                                        </template>
                                        <span v-if="!passo.produtos.length">Etapa não vinculada a nenhum produto</span>
                                        <div v-else>
                                            <div class="font-weight-bold mb-1">
                                                Vinculada a {{ passo.produtos.length }} {{ passo.produtos.length === 1 ? 'produto' : 'produtos' }}
                                            </div>
                                            <div v-for="p in produtosNoTooltip(passo)" :key="p.id">
                                                {{ p.descricao }}<span v-if="p.status === 'inativo'" class="grey--text text--lighten-1"> (inativo)</span>
                                            </div>
                                            <div v-if="passo.produtos.length > produtosNoTooltip(passo).length" class="grey--text text--lighten-1 mt-1">
                                                + {{ passo.produtos.length - produtosNoTooltip(passo).length }} outros
                                            </div>
                                        </div>
                                    </v-tooltip>
                                </div>
                                <div class="ml-2 mb-2">
                                    <v-chip
                                        v-for="canal in canaisRestritos(passo)"
                                        :key="canal"
                                        x-small
                                        outlined
                                        class="ml-1"
                                        :color="semCanal(passo) ? 'error' : ''"
                                    >{{ canal }}</v-chip>
                                </div>
                            </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pt-4">
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-text-field
                                        v-model="passo.id"
                                        dense
                                        outlined
                                        readonly
                                        filled
                                        label="Código"
                                        placeholder="auto"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="12" sm="10">
                                    <v-text-field
                                        v-model="passo.identificacao"
                                        dense
                                        outlined
                                        label="Identificação (uso interno)"
                                        placeholder="Sabores - Pizza Grande"
                                        hide-details
                                    >
                                        <template #append>
                                            <v-tooltip bottom max-width="280">
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                                </template>
                                                <span>Nome para identificar esta etapa no cadastro. O cliente final não vê essa informação.</span>
                                            </v-tooltip>
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="passo.descricao"
                                        dense
                                        outlined
                                        label="Descrição (aparece na impressão do pedido)"
                                        placeholder="Sabores"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        v-model="passo.titulo"
                                        dense
                                        outlined
                                        label="Titulo (aparece no cardápio digital)"
                                        placeholder="Escolha os sabores"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-select
                                        v-model="passo.forma_calculo"
                                        :items="['Soma', 'Média', 'Maior valor']"
                                        label="Forma de cálculo"
                                        dense
                                        outlined
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-select
                                        v-model="passo.formato_quantidade"
                                        :items="['Fração', 'Unidade']"
                                        label="Formatação da quantidade"
                                        dense
                                        outlined
                                        hide-details
                                    />
                                    <span style="font-size: 12px; color: #888">Exemplo: Fração (1/4), Unidade (2x)</span>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="pa-3">
                                    <div class="text-caption grey--text mb-2">Onde esta etapa é oferecida</div>
                                    <div class="d-flex flex-wrap align-center" style="gap: 12px 24px;">
                                        <v-switch
                                            v-model="passo.mostra_cardapio"
                                            label="Cardápio Digital"
                                            dense
                                            inset
                                            hide-details
                                            class="mt-0 pt-0"
                                        />
                                        <v-switch
                                            v-model="passo.mostra_comanda"
                                            label="Gestor de Pedidos"
                                            dense
                                            inset
                                            hide-details
                                            class="mt-0 pt-0"
                                        />
                                        <div class="d-flex align-center">
                                            <v-switch
                                                v-model="passo.mostra_tablet"
                                                label="Tablet"
                                                dense
                                                inset
                                                hide-details
                                                class="mt-0 pt-0"
                                            />
                                            <v-tooltip bottom max-width="320">
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                                                </template>
                                                <span>
                                                    Nos canais desligados o cliente não passa por esta etapa — o produto
                                                    vai direto para o carrinho. Útil para etapas que só fazem sentido no
                                                    salão, como copo e gelo para bebidas.
                                                </span>
                                            </v-tooltip>
                                        </div>
                                    </div>
                                    <div v-if="semCanal(passo)" class="text-caption error--text mt-2">
                                        Com os três desligados, esta etapa não é oferecida em nenhum canal.
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row v-if="hasIfoodCatalogo">
                                <v-col cols="12" sm="6">
                                    <v-select
                                        v-model="passo.ifood_tipo"
                                        :items="ifoodTipos"
                                        label="Tipo no iFood (pizza)"
                                        dense
                                        outlined
                                        hide-details
                                        clearable
                                    />
                                    <span style="font-size: 12px; color: #888">Só em etapas de pizza: Sabores, Massa ou Borda.</span>
                                </v-col>
                            </v-row>

                            <v-row v-if="hasFichaTecnica">
                                <v-col cols="12" class="d-flex align-center pa-3">
                                    <v-switch
                                        v-model="passo.escala_com_tamanho"
                                        label="Quantidade dos ingredientes varia por produto"
                                        dense
                                        inset
                                        hide-details
                                        class="mt-0 pt-0"
                                    />
                                    <v-tooltip bottom max-width="320">
                                        <template #activator="{ on, attrs }">
                                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
                                        </template>
                                        <span>
                                            Ligue para etapas em que produtos maiores usam mais dos mesmos ingredientes
                                            (ex: tamanhos de pizza). Em cada produto você informa o multiplicador da ficha.
                                            Deixe desligado para itens de quantidade fixa (ex: azeitonas).
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" class="pa-3">
                                    <v-btn
                                        color="primary"
                                        block
                                        small
                                        @click="openComplementosDialog(i)"
                                    >
                                        <v-icon>mdi-plus</v-icon>Add Complementos
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <div style="display: flex; align-items: center;" class="mt-4">
                                <div
                                    style="font-weight: bold;"
                                    v-if="hasComplementos(passo.complementos)"
                                >
                                    Complementos
                                </div>
                                <v-btn
                                    @click="sortComplementos(i)"
                                    color="primary"
                                    icon
                                >
                                    <v-icon>mdi-sort-alphabetical-ascending</v-icon>
                                </v-btn>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            small
                                            :color="blockDraggable ? '' : 'primary'"
                                            @click="blockDraggable = !blockDraggable"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon :class="{ shake: shakeLockIcon }">
                                                {{ blockDraggable ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ blockDraggable ? 'Desbloquear ordenação' : 'Salvar ordenação' }}</span>
                                </v-tooltip>
                            </div>
                            <draggable
                                v-model="passo.complementos"
                                :disabled="blockDraggable"
                                class="mb-12 mt-4"
                            >
                                <v-row
                                    class="ml-1 mb-1"
                                    style="display: flex; border: 1px solid #ddd; border-radius: 10px; padding: 10px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);"
                                    v-for="(c, ia) in passo.complementos"
                                    :key="ia"
                                >
                                    <v-col cols="12" md="4" class="d-flex align-center pa-0">
                                        <v-icon
                                            style="cursor: move;"
                                            @mousedown="handleDragIconClick"
                                        >
                                            mdi-drag-vertical
                                        </v-icon>
                                        <h3 class="text-truncate" style="min-width: 0;">{{ c.descricao }}</h3>
                                    </v-col>
                                    <v-col cols="12" md="8" class="pa-0">
                                        <div class="d-flex align-center flex-wrap" style="gap: 8px;">
                                            <v-text-field
                                                v-model="c.valor"
                                                :prefix="moeda()"
                                                outlined
                                                dense
                                                label="Valor Adicional"
                                                v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                                                style="flex: 2 1 120px;"
                                                hide-details
                                            />
                                            <v-text-field
                                                v-if="hasIfoodCatalogo"
                                                v-model="c.valor_ifood"
                                                :prefix="moeda()"
                                                outlined
                                                dense
                                                label="Valor iFood"
                                                placeholder="igual"
                                                v-mask="['#.##','##.##','###.##','####.##','#####.##']"
                                                style="flex: 2 1 120px;"
                                                hide-details
                                            />
                                            <v-text-field
                                                v-model="c.min"
                                                outlined
                                                dense
                                                label="Min"
                                                type="number"
                                                style="flex: 1 1 64px;"
                                                hide-details
                                            />
                                            <v-text-field
                                                v-model="c.max"
                                                outlined
                                                dense
                                                label="Max"
                                                type="number"
                                                style="flex: 1 1 64px;"
                                                hide-details
                                            />
                                            <v-btn icon color="error" class="flex-shrink-0" @click="remove(ia, i)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-4">
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-btn
                                            @click="deleteStep(passo.id, i)"
                                            color="error"
                                            small
                                        >
                                            <v-icon small>mdi-delete</v-icon> Excluir
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-btn
                                            @click="duplicateStep(i)"
                                            color="primary"
                                            small
                                        >
                                            <v-icon small>mdi-plus-circle-multiple-outline</v-icon> Duplicar
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="4" class="d-flex justify-center">
                                        <v-btn
                                            @click="saveStep(i)"
                                            :loading="loadingSalvar === i"
                                            color="success"
                                            small
                                        >
                                            <v-icon small>mdi-content-save</v-icon> Salvar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </draggable>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <div v-if="!showExcluidos && isSuporte" class="d-flex justify-center mt-4">
                    <v-btn
                        text
                        small
                        color="error"
                        :loading="loadingExcluidos"
                        @click="consultarExcluidos"
                    >
                        <v-icon left small>mdi-delete-outline</v-icon>
                        Exibir excluídos
                    </v-btn>
                </div>

                <div v-if="showExcluidos" class="mt-4">
                    <v-divider class="mb-3"/>
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
                        <v-icon color="error">mdi-delete-outline</v-icon>
                        <span style="font-weight: bold; color: #e53935;">Etapas Excluídas</span>
                        <v-chip x-small color="error" outlined>{{ passosExcluidos.length }}</v-chip>
                    </div>
                    <div v-if="passosExcluidos.length === 0" style="text-align: center; color: #999; padding: 16px;">
                        Nenhuma etapa excluída
                    </div>
                    <v-expansion-panels v-model="panelExcluidos" v-else>
                        <v-expansion-panel
                            v-for="(passo, i) in passosExcluidos"
                            :key="'excluido-' + i"
                            class="excluido-panel"
                        >
                            <v-expansion-panel-header>
                                <div style="display: flex; align-items: center; gap: 8px; opacity: 0.6;">
                                    <v-icon color="error" small>mdi-delete</v-icon>
                                    <span style="font-weight: bold; text-transform: uppercase; text-decoration: line-through; color: #888;">
                                        {{ passo.id ? `${passo.id} - ` : '' }}{{ rotulo(passo) }}
                                    </span>
                                </div>
                                <template v-slot:actions>
                                    <v-btn
                                        small
                                        color="success"
                                        outlined
                                        @click.stop="restoreStep(passo.id)"
                                        :loading="loadingRestore === passo.id"
                                        style="margin-right: 8px;"
                                    >
                                        <v-icon left small>mdi-restore</v-icon>
                                        Restaurar
                                    </v-btn>
                                    <v-icon>mdi-chevron-down</v-icon>
                                </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="pt-2">
                                <div style="opacity: 0.55;">
                                    <v-row>
                                        <v-col cols="12" sm="2">
                                            <v-text-field
                                                :value="passo.id"
                                                dense outlined readonly filled
                                                label="Código" hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="10">
                                            <v-text-field
                                                :value="passo.identificacao"
                                                dense outlined readonly filled
                                                label="Identificação" hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-1">
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                :value="passo.descricao"
                                                dense outlined readonly filled
                                                label="Descrição" hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                :value="passo.titulo"
                                                dense outlined readonly filled
                                                label="Titulo" hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-1">
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                :value="passo.forma_calculo"
                                                dense outlined readonly filled
                                                label="Forma de cálculo" hide-details
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                :value="passo.formato_quantidade"
                                                dense outlined readonly filled
                                                label="Formatação da quantidade" hide-details
                                            />
                                        </v-col>
                                    </v-row>
                                    <div
                                        v-if="passo.complementos && passo.complementos.length"
                                        class="mt-3"
                                        style="font-weight: bold; margin-bottom: 8px;"
                                    >
                                        Complementos ({{ passo.complementos.length }})
                                    </div>
                                    <v-chip
                                        v-for="(c, ci) in passo.complementos"
                                        :key="ci"
                                        class="mr-1 mb-1"
                                        small
                                        outlined
                                    >
                                        {{ c.descricao }}
                                    </v-chip>
                                </div>
                                <div class="d-flex justify-center mt-3">
                                    <v-btn
                                        color="success"
                                        @click="restoreStep(passo.id)"
                                        :loading="loadingRestore === passo.id"
                                    >
                                        <v-icon left>mdi-restore</v-icon>
                                        Restaurar etapa
                                    </v-btn>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </v-card-text>
        </v-card>

        <CadastroComplementos
            :visible="dialog"
            @save="onSaveComplemento"
            @close="closeCadastroComplemento"
        />

        <v-dialog v-model="complementosDialog.visible" max-width="700">
            <v-card>
                <v-card-title class="pb-2">
                    <span class="text-h6">Adicionar complementos</span>
                    <v-spacer/>
                    <v-btn icon @click="complementosDialog.visible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-text-field
                        v-model="complementosDialog.search"
                        append-icon="mdi-magnify"
                        label="Pesquisar complemento"
                        dense
                        hide-details
                        outlined
                    />
                </v-card-text>
                <v-card-title>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text small color="primary" v-bind="attrs" v-on="on" title="Selecionar por categoria">
                                Selecionar todos
                                <v-icon right>mdi-menu-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-item
                                v-for="(categoria, index) in getCategorias"
                                :key="index"
                                @click="selectAllCategoriaDialog(categoria)"
                                style="cursor: pointer;"
                            >
                                <v-list-item-title>Selecionar todos {{ categoria }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-spacer/>
                    <v-btn
                        small
                        outlined
                        color="primary"
                        class="mr-2"
                        @click="newComplemento"
                        >
                        <v-icon left>mdi-plus</v-icon> Novo
                    </v-btn>
                </v-card-title>

                <v-divider/>

                <v-card-text :style="`height: ${$vuetify.breakpoint.height - 350}px; overflow-x: auto;`">
                    <div v-for="(categoria, index) in categoriasComComplementos" :key="index" class="mb-2">
                        <div style="font-weight: bold; margin-bottom: 8px; margin-top: 20px;">
                            {{ categoria.nome }}
                        </div>
                        <v-row>
                            <v-col
                                cols="12"
                                sm="6"
                                v-for="item in categoria.itens"
                                :key="item.value"
                                style="padding: 3px;"
                            >
                                <v-card
                                    class="px-2 d-flex align-center"
                                    @click="toggleComplemento(item)"
                                    :style="
                                        selectedComplementos.includes(item)
                                        ? 'border-radius: 5px; border: solid 1px #777'
                                        : ''
                                    "
                                    >
                                    <v-checkbox
                                        :input-value="selectedComplementos.includes(item)"
                                        class="mr-3"
                                        color="primary"
                                    />
                                    <div>
                                        <div style="font-weight: bold;">{{ item.descricao }}</div>
                                        <div style="font-size: 13px; color: #666;">
                                        {{ item.categoria?.descricao }} | {{ moeda() }} {{ formatPrice(item.valor) }}
                                        </div>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-btn @click="complementosDialog.visible = false" text color="warning">
                        Cancelar
                    </v-btn>
                    <v-spacer />
                    <v-btn color="primary" @click="confirmarComplementos">
                        Add Selecionados
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import { moeda } from '@/utils/moeda';
import { mapState } from 'vuex';
import CadastroComplementos from './CadastroComplementos';
import draggable from 'vuedraggable';
import { hasModule, hasIfoodCatalogo } from '@/utils/module';
import { rotuloEtapa } from '@/utils/etapa';

// Acima disso o tooltip passaria da altura da tela; o resto vira "+ N outros"
const PRODUTOS_NO_TOOLTIP = 15;

export default {
    name: 'Steps',

    components: { CadastroComplementos, draggable },

    // etapaId: etapa a abrir expandida (lápis na linha da etapa no cadastro de produto)
    props: ['visible', 'etapaId'],

    data: () => ({
        loadingSalvar: null,
        loading: false,
        loadingExcluidos: false,
        loadingRestore: null,
        dialog: false,
        blockDraggable: true,
        shakeLockIcon: false,
        panel: '',
        panelExcluidos: '',
        values: [],
        complementos: [],
        passos: [],
        passosExcluidos: [],
        showExcluidos: false,
        complementosDialog: {
            visible: false,
            index: null,
            search: '',
        },
        selectedComplementos: [],
        ifoodTipos: [
            { text: 'Sabores (TOPPING)', value: 'TOPPING' },
            { text: 'Massa (CRUST)', value: 'CRUST' },
            { text: 'Borda (EDGE)', value: 'EDGE' },
        ],
    }),

    computed: {
        ...mapState(['usuario']),

        hasFichaTecnica() {
            return hasModule('FICHA_TECNICA');
        },

        hasIfoodCatalogo() {
            return hasIfoodCatalogo();
        },

        isSuporte() {
            return this.usuario.tipo === 'suporte';
        },

        getComplementos() {
            // Ordena o array e insere as divisorias por categoria
            let categorias = [];
            const complementos = JSON.parse(JSON.stringify(this.complementos));

            const sorted = complementos.sort((a, b) => {
                let catA = a.categoria?.id;
                let catB = b.categoria?.id;

                return (catA > catB) ? 1 : ((catB > catA) ? -1 : 0)
            });

            sorted.forEach(s => {
                let cat = s.categoria?.descricao;
                !categorias.includes(cat) && categorias.push(cat)
            });

            categorias.forEach(c => {
                const index = sorted.findIndex(i => c == i.categoria?.descricao);
                sorted.splice(index, 0, {header: c});
            });

            return sorted;
        },

        getCategorias() {
            return [...new Set(this.complementos.map(item => item.categoria?.descricao))];
        },

        filteredComplementos() {
            const term = this.complementosDialog.search?.toLowerCase() || '';
            return this.getComplementos.filter(c =>
                c.descricao?.toLowerCase().includes(term) ||
                c.categoria?.descricao?.toLowerCase().includes(term)
            );
        },

        categoriasComComplementos() {
            const lista = this.filteredComplementos;
            const categorias = {};

            lista.forEach(item => {
                const nome = item.categoria?.descricao || 'Sem categoria';
                if (!categorias[nome]) categorias[nome] = [];
                categorias[nome].push(item);
            });

            return Object.entries(categorias).map(([nome, itens]) => ({
                nome,
                itens,
            }));
        },
    },

    mounted() {
        this.initialize();
    },

    watch: {
        visible(v) {
            if (!v) {
                // Ao fechar, recolhe todas as etapas (ativas e excluídas)
                this.panel = '';
                this.panelExcluidos = '';
                return;
            }

            this.atualizarProdutos();
            this.etapaId && this.expandirEtapa(this.etapaId);
        },
    },

    methods: {
        rotulo: rotuloEtapa,

        expandirEtapa(id) {
            const index = this.passos.findIndex(p => p.id === id);
            if (index === -1) {
                return;
            }

            this.panel = index;
            // Espera a abertura do diálogo e do painel para rolar até a etapa
            setTimeout(() => {
                this.$refs.paineis?.[index]?.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        },

        initialize() {
            this.consultar();
            this.fillComplementos();
        },

        consultar() {
            this.loading = true;
            this.$http.get('passos?com_produtos=1').then(resp => {
                this.passos = resp.data.data;
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            })
            .finally(() => (this.loading = false));
        },

        /**
         * O diálogo fica montado junto do cadastro de produto, então os vínculos carregados no início
         * envelhecem quando um produto é salvo. Atualiza só os produtos de cada etapa, sem descartar
         * o que estiver sendo editado.
         */
        atualizarProdutos() {
            if (this.loading) {
                return;
            }

            this.$http.get('passos?com_produtos=1').then(resp => {
                const produtosPorEtapa = {};
                resp.data.data.forEach(p => (produtosPorEtapa[p.id] = p.produtos));
                this.passos.forEach(p => {
                    p.id && produtosPorEtapa[p.id] && (p.produtos = produtosPorEtapa[p.id]);
                });
            });
        },

        produtosNoTooltip(passo) {
            return passo.produtos.slice(0, PRODUTOS_NO_TOOLTIP);
        },

        fillComplementos() {
            this.complementos = [];
            this.$http.get('complementos').then(resp => {
                resp.data.data.forEach(c => {
                    this.complementos.push({
                        value: c.id,
                        text: `${c.descricao} | ${c.categoria.descricao} | ${moeda()} ${this.formatPrice(+c.valor || 0)}`,
                        descricao: c.descricao,
                        detalhes: c.detalhes,
                        categoria: c.categoria,
                        valor: c.valor,
                    });
                });
            })
            .catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        addComplementos(index) {
            this.values.forEach(v => {
                this.passos[index].complementos.push({
                    id: null,
                    complemento_id: v.value,
                    descricao: v.descricao,
                    detalhes: v.detalhes,
                    // categoria: v.categoria,
                    ativo: true,
                    min: v.min || '',
                    max: v.max || '',
                    valor: (+v.valor || 0).toFixed(2),
                    valor_ifood: '',
                });
            });

            this.values = [];
        },

        sortComplementos(index) {
            if (!confirm('Deseja realmente ordenar por ordem alfabética?')) {
                return;
            }

            const alphabeticalSorter = (a, b) => a.descricao.localeCompare(b.descricao);
            this.passos[index].complementos.sort(alphabeticalSorter);
            this.$forceUpdate();
        },

        remove(ia, i) {
            this.passos[i].complementos.splice(ia, 1);
        },

        saveStep(i) {
            const data = this.passos[i];
            const id = data.id;

            if (!data.complementos.length) {
                this.notify('Nenhum complemento adicionado na etapa', 'warning');
                return;
            } else {
                const item = data.complementos.find(e => e.valor === '');
                if (item) {
                    this.notify(`Informe o valor de ${item.descricao}`, 'warning');
                    return;
                }
            }

            if (!data.identificacao) {
                this.notify('Informe a identificação', 'warning');
                return;
            }

            if (!data.descricao) {
                this.notify('Informe a descrição', 'warning');
                return;
            }

            if (!data.titulo) {
                this.notify('Informe o título', 'warning');
                return;
            }

            if (!data.forma_calculo) {
                this.notify('Informe a forma de cálculo', 'warning');
                return;
            }

            if (!data.formato_quantidade) {
                this.notify('Informe a formatação da quantidade', 'warning');
                return;
            }

            if (id) {
                this.loadingSalvar = i;
                this.$http.put(`passos/${id}`, data).then(() => {
                    this.$emit('save');
                    this.notify('Atualizado com sucesso!');
                    this.consultar();
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.loadingSalvar = null));
                return;
            }

            this.loadingSalvar = i;
            this.$http.post('passos', data).then(() => {
                this.$emit('save');
                this.notify('Salvo com sucesso!');
                this.consultar();
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loadingSalvar = null));
        },

        addStep() {
            this.passos.unshift({
                id: null,
                identificacao: '',
                descricao: '',
                detalhes: '',
                titulo: '',
                forma_calculo: '',
                formato_quantidade: '',
                escala_com_tamanho: false,
                ifood_tipo: null,
                mostra_cardapio: true,
                mostra_comanda: true,
                mostra_tablet: true,
                complementos: []
            });
            this.panel = 0; //expand only the first
        },

        async deleteStep(id, index) {
            if (!id) {
                this.passos.splice(index, 1);
                return;
            }

            if (await this.$root.$confirm('Confirmação', 'Deseja realmente excluir a etapa?', { color: 'red darken-1' })) {
                this.$http.delete(`passos/${id}`).then(() => {
                    this.$emit('delete', id);
                    this.notify('Excluído com sucesso!');
                    this.consultar();
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                });
            }
        },

        async duplicateStep(i) {
            if (!await this.$root.$confirm('Confirmação', 'Deseja realmente duplicar a etapa?', { color: 'red darken-1' })) {
                return;
            }
            const passo = JSON.parse(JSON.stringify(this.passos[i]));
            console.log(passo)
            passo.id = null;
            // A cópia sai com a mesma descrição (é o que o cliente lê na impressão); quem ganha
            // o sufixo é a identificação, que existe justamente para separar as duas no cadastro.
            passo.identificacao = rotuloEtapa(passo) + ' - Cópia';
            // A cópia ainda não está em nenhum produto
            delete passo.produtos;
            passo.complementos.forEach(c => {
                c.complemento_id = c.pivot.complemento_id;
                c.id = null;
            });
            this.passos.push(passo);
        },

        hasComplementos(complementos) {
            return complementos?.length;
        },

        semCanal(passo) {
            return !passo.mostra_cardapio && !passo.mostra_comanda && !passo.mostra_tablet;
        },

        canaisRestritos(passo) {
            const canais = [];
            passo.mostra_cardapio && canais.push('Cardápio');
            passo.mostra_comanda && canais.push('Gestor');
            passo.mostra_tablet && canais.push('Tablet');

            if (canais.length === 3) {
                return [];
            }

            return canais.length ? canais : ['Nenhum canal'];
        },

        newComplemento() {
            this.dialog = true;
        },

        closeCadastroComplemento() {
            this.dialog = false;
        },

        onSaveComplemento() {
            this.fillComplementos();
            this.notify('Salvo com sucesso!');
        },

        openComplementosDialog(index) {
            this.complementosDialog.visible = true;
            this.complementosDialog.index = index;
            this.complementosDialog.search = '';
            this.selectedComplementos = [];
        },

        toggleComplemento(item) {
            const index = this.selectedComplementos.findIndex(c => c.value === item.value);
            if (index === -1) {
                this.selectedComplementos.push(item);
            } else {
                this.selectedComplementos.splice(index, 1);
            }
            this.$forceUpdate();
        },

        confirmarComplementos() {
            const i = this.complementosDialog.index;
            this.selectedComplementos.forEach(v => {
                if (!this.passos[i].complementos.some(c => c.descricao === v.descricao)) {
                this.passos[i].complementos.push({
                    id: null,
                    complemento_id: v.value,
                    descricao: v.descricao,
                    detalhes: v.detalhes,
                    ativo: true,
                    min: v.min || '',
                    max: v.max || '',
                    valor: (+v.valor || 0).toFixed(2),
                });
                }
            });
            this.complementosDialog.visible = false;
        },

        selectAllCategoriaDialog(categoria) {
            this.getComplementos.forEach(e => {
                if (
                    e.categoria?.descricao === categoria &&
                    !this.selectedComplementos.some(sel => sel.value === e.value)
                ) {
                    this.selectedComplementos.push(e);
                }
            });
        },

        handleDragIconClick() {
            if (this.blockDraggable) {
                this.shakeLockIcon = true;
                setTimeout(() => {
                    this.shakeLockIcon = false;
                }, 600);
            }
        },

        consultarExcluidos() {
            this.loadingExcluidos = true;
            this.$http.get('passos/excluidos').then(resp => {
                this.passosExcluidos = resp.data.data;
                this.showExcluidos = true;
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loadingExcluidos = false));
        },

        async restoreStep(id) {
            if (!await this.$root.$confirm('Confirmação', 'Deseja restaurar esta etapa?', { color: 'success' })) {
                return;
            }
            this.loadingRestore = id;
            this.$http.put(`passos/${id}/restore`).then(() => {
                this.notify('Etapa restaurada com sucesso!');
                this.passosExcluidos = this.passosExcluidos.filter(p => p.id !== id);
                this.consultar();
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loadingRestore = null));
        },
    },
}
</script>

<style scoped>
.v-expansion-panel-header--active {
    background-color: #ddd !important;
}

.col {
    padding: 0;
}

.v-card__text {
    padding: 0;
}

@media (max-width: 600px) {
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 16px 16px;
  }
}

@keyframes shake {
  0% { transform: translateX(0); }
  20% { transform: translateX(-5px); }
  40% { transform: translateX(5px); }
  60% { transform: translateX(-5px); }
  80% { transform: translateX(5px); }
  100% { transform: translateX(0); }
}

.shake {
  animation: shake 0.4s ease;
}

.chip-sem-produto {
  border-style: dashed !important;
}

.excluido-panel {
  opacity: 0.7;
  border-left: 3px solid #e53935 !important;
  background-color: #fff5f5 !important;
}

.excluido-panel:hover {
  opacity: 0.9;
}
</style>
